import script from "./RelinkAccountsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./RelinkAccountsPage.vue?vue&type=script&setup=true&lang=ts"

import "./RelinkAccountsPage.vue?vue&type=style&index=0&id=712e66bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-712e66bd"]])

export default __exports__